__turbopack_context__.v({
  "checkIcon": "ModuleCheckbox-module-scss-module__xCrWpW__checkIcon",
  "checkbox": "ModuleCheckbox-module-scss-module__xCrWpW__checkbox",
  "enter": "ModuleCheckbox-module-scss-module__xCrWpW__enter",
  "exit": "ModuleCheckbox-module-scss-module__xCrWpW__exit",
  "fade-in": "ModuleCheckbox-module-scss-module__xCrWpW__fade-in",
  "fade-out": "ModuleCheckbox-module-scss-module__xCrWpW__fade-out",
  "fade-out-80": "ModuleCheckbox-module-scss-module__xCrWpW__fade-out-80",
  "size24": "ModuleCheckbox-module-scss-module__xCrWpW__size24",
  "size32": "ModuleCheckbox-module-scss-module__xCrWpW__size32",
  "slide-in-from-bottom": "ModuleCheckbox-module-scss-module__xCrWpW__slide-in-from-bottom",
  "slide-in-from-left": "ModuleCheckbox-module-scss-module__xCrWpW__slide-in-from-left",
  "slide-in-from-right": "ModuleCheckbox-module-scss-module__xCrWpW__slide-in-from-right",
  "slide-in-from-top": "ModuleCheckbox-module-scss-module__xCrWpW__slide-in-from-top",
  "slide-out-to-bottom": "ModuleCheckbox-module-scss-module__xCrWpW__slide-out-to-bottom",
  "slide-out-to-left": "ModuleCheckbox-module-scss-module__xCrWpW__slide-out-to-left",
  "slide-out-to-right": "ModuleCheckbox-module-scss-module__xCrWpW__slide-out-to-right",
  "slide-out-to-top": "ModuleCheckbox-module-scss-module__xCrWpW__slide-out-to-top",
  "zoom-in": "ModuleCheckbox-module-scss-module__xCrWpW__zoom-in",
  "zoom-out": "ModuleCheckbox-module-scss-module__xCrWpW__zoom-out",
});
